import cloneDeep from 'lodash.clonedeep';
import type { Vehicle } from '../../../@types/Vehicle';

class AssignmentDto {
  id = null;
  vehicle: Vehicle;
  shortDescription = '';
  description = '';
  media = [];
  position = {};
  contactOptions = [];
  interestedInTradeIn = false;

  constructor(vehicle: Vehicle | undefined | null) {
    if (!vehicle) throw new Error('Vehicle is required');
    this.vehicle = vehicle;

    if (vehicle && vehicle.modelName && !this.shortDescription)
      this.shortDescription = vehicle.modelName;
  }

  static fromLookup = (vehicle: Vehicle | undefined | null) =>
    new AssignmentDto(cloneDeep(vehicle));
}

export default AssignmentDto;
